/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { SystemManagerComponent } from '../../components/system-manager/system-manager.component';
import { GlobalConstants } from '../../constants/global-constants';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { SystemManagerInfo } from '../../models/system-manager-model';
import { PopupDialog } from '../popup-dialog.interface';

export class SystemManagerDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig): any {
    sysquePopupConfig.component = SystemManagerComponent;
    sysquePopupConfig.data = new SystemManagerInfo();
    (sysquePopupConfig.data as SystemManagerInfo).importButton = GlobalConstants.ImportSystemsButton;
    (sysquePopupConfig.data as SystemManagerInfo).columnsName = GlobalConstants.ColumnsName;
    (sysquePopupConfig.data as SystemManagerInfo).addButton = GlobalConstants.AddSystemButton;
    (sysquePopupConfig.data as SystemManagerInfo).exportButton = GlobalConstants.ExportButton;
    (sysquePopupConfig.data as SystemManagerInfo).cancelRequestButton = GlobalConstants.CancelRequestButton;
    sysquePopupConfig.width = 900;
    sysquePopupConfig.height = 780;
    sysquePopupConfig.componentTitle = GlobalConstants.SYSTEM_MANAGER_DIALOG;
    sysquePopupConfig.visible = true;
  }
}
